export default {
  route: {
    dashboard: 'Dashboard',
    introduction: 'Introduction',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    icons: 'Icons',
    components: 'Components',
    componentIndex: 'Introduction',
    example: 'Example',
    Table: 'Table',
    tab: 'Tab',
    form: 'Form',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link'
  },
  navbar: {
    home: 'Home',
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    screenfull: 'Full screen',
    theme: 'Theme',
    size: 'Size',
    userProfile: 'Profile',
    international: 'Language',
    logout: 'Logout',
    settings: 'Settings',
    changePassword: 'Password',
    removecache: 'Clear cache',
    notificationActive: 'Active Notifications'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    login: 'Login',
    password: 'Password',
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    type: 'Type',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  search: {
    search: 'Search',
    label: 'Label'
  },
  action: {
    search: 'Search',
    cancel: 'Cancel',
    close: 'Close',
    replace: 'Replace',
    confirm: 'Confirm',
    add: 'Add',
    clear: 'Clear',
    clearAll: 'Clear All',
    reset: 'Reset',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  symbol: 'Instrument',
  currency: 'Currency',
  TopExposureKey: 'Top Exposure',
  TopPnLKey: 'Top P&L',
  TopHedgingKey: 'Top Hedging',
  HedgingKey: 'Hedging',
  AccountEquity: 'Equity',
  CashMnt: 'Balance',
  usedMargin: 'Margin',
  FreeMargin: 'Free',
  usedMarginPerc: '%',
  NOP: 'NOP'
}
